import type { ComponentType, SVGProps } from "react";

type SidebarMenuIconProps = {
  active?: boolean;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
};

const SidebarMenuIcon = ({ active = false, icon: Icon }: SidebarMenuIconProps) => {
  return (
    <Icon
      className={active ? "h-4 w-4 shrink-0 text-white" : "h-4 w-4 shrink-0 text-[#B4B9CA]"}
    />
  );
};

export default SidebarMenuIcon;
